import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form";
import { getValue } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  EField,
  IExtraData,
} from "./schema.propertyApplicationNotEligible.types";

export const getSchema =
  (
    initialValues: {
      [key: string]: any;
    },
    extraData: IExtraData,
  ) =>
  (defaultValues: { [key: string]: any }) => ({
    required: [EField.TenantFeedbackText],
    properties: {
      [EField.TenantFeedbackText]: {
        default: getValue(
          EField.TenantFeedbackText,
          initialValues,
          defaultValues,
        ),
      },
    },
  });

export const uiSchema = (_: IExtraData) => ({
  "rentio:navigationTitle": getLocalizedText(
    "property.application.not_eligible.title",
  ),
  [EField.TenantFeedbackText]: {
    "ui:field": ERentioFormField.Text,
    title: getLocalizedText("property.application.not_eligible.message.label"),
    autoFocus: true,
    multiline: true,
  },
});
